////////////////////////////////////////
// Common functions required by forms //
////////////////////////////////////////

export const showError = (errors, field) => {
  if (!errors || errors[field] === undefined) {
    return '';
  }

  if (typeof errors[field] === 'object' && Object.prototype.toString.call(errors[field]) !== '[object Array]') {
    const messages = [];
    Object.keys(errors[field]).forEach((key) => {
      messages.push(`${field}'s ${key}: ${errors[field][key].join(', ')}`);
    });
    return messages.join(', ');
  }

  return errors[field].join(', ');
};

export const showErrorItem = (errors, list, idx, field) => {
  if (!errors || errors[list] === undefined) {
    return '';
  }
  if (errors[list][idx][field] === undefined) {
    return '';
  }
  return errors[list][idx][field].join(', ');
};


export const getClassName = (errors, field, clsName) => {
  const className = clsName ? clsName : 'is-invalid';
  if (!errors || errors[field] === undefined) {
    return '';
  }

  if (typeof errors[field] === 'object' && Object.prototype.toString.call(errors[field]) !== '[object Array]') {
    return 'is-invalid';
  }


  return errors[field].length > 0 ? className : '';
};

export const getClassNameItem = (errors, list, idx, field, clsName) => {
  const className = clsName ? clsName : 'is-invalid';
  if (!errors || !errors[list]) {
    return '';
  }
  if (errors[list][idx][field] === undefined) {
    return '';
  }
  return errors[list][idx][field].length > 0 ? className : '';
};



// WEBPACK FOOTER //
// ./src/_helpers/form.js